import { ApiService } from './ApiService';
import { Result, ResultOf } from '@/types/result';

/**
 * Ответ метода GetUpsellModalInfo (апселл после отмены, FINCH-2324)
 */
export interface UpsellModalInfoResponse {
    /** Нужно ли показать модалку */
    shouldShow: boolean;
    /** Ключ модалки — передать обратно в DismissUpsellModal */
    modalKey?: string;
}

/**
 * Ответ метода GetPackagesAnnouncementModalInfo (анонс пакетов 3/6/12 мес, FINCH-2446).
 * Повод один, поэтому ключ модалки клиенту не нужен — им владеет сервер.
 */
export interface PackagesAnnouncementModalInfoResponse {
    /** Нужно ли показать модалку */
    shouldShow: boolean;
}

/**
 * Модалки при входе поверх generic-реестра UserModalShown.
 */
export class UserModalsApi extends ApiService {
    base = 'UserModals';

    /**
     * Получить информацию о модалке апселла после отмены (FINCH-2324) для показа при входе
     */
    async getUpsellModalInfo(): Promise<ResultOf<UpsellModalInfoResponse>> {
        return await this.get(this.getUrl('GetUpsellModalInfo'));
    }

    /**
     * Пометить модалку апселла после отмены как показанную
     * @param modalKey Ключ модалки из getUpsellModalInfo
     */
    async dismissUpsellModal(modalKey: string): Promise<Result> {
        return await this.post(this.getUrl('DismissUpsellModal'), { modalKey });
    }

    /**
     * Получить информацию о модалке-анонсе запуска пакетов на 3/6/12 месяцев (FINCH-2446)
     */
    async getPackagesAnnouncementModalInfo(): Promise<ResultOf<PackagesAnnouncementModalInfoResponse>> {
        return await this.get(this.getUrl('GetPackagesAnnouncementModalInfo'));
    }

    /**
     * Пометить модалку-анонс запуска пакетов как показанную
     */
    async dismissPackagesAnnouncementModal(): Promise<Result> {
        return await this.post(this.getUrl('DismissPackagesAnnouncementModal'), {});
    }
}
